export function isWebUrl(url: string): boolean {
  return url.startsWith("http://") || url.startsWith("https://");
}
